import { isPositiveNumber, reduce } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import getUserPaymentsStore from "../../../../stores/user-store/payments-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import React from "react";

import Et3Table from "../../../../core/et3-table";
import {
  SUBSCRIPTION_PAYMENT_HISTORY_HEADERS,
  SUBSCRIPTION_REWIND_BOOST_PAYMENT_HISTORY_HEADERS
} from "../../../../constants/table-custom-headers/User";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const UserPaymentsTables = withLiteObserverAndTheme(() => {
  const paymentsData = getUserPaymentsStore().userPaymentData.get();
  const userID = reduce(() => paymentsData.userID, -1);
  const reducedStringUserId = isPositiveNumber(userID) ? `${userID}` : "";

  return (
    <React.Fragment>
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.silverSubscriptionPaymentHistory}
        title={`${i18n.get(
          "SILVER_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"SILVER_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.goldSubscriptionPaymentHistory}
        title={`${i18n.get(
          "GOLD_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"GOLD_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.platinumSubscriptionPaymentHistory}
        title={`${i18n.get(
          "PLATINUM_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"PLATINUM_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.powerBundleSubscriptionPaymentHistory}
        title={`${i18n.get(
          "POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"POWER_BUNDLE_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_REWIND_BOOST_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.readSubscriptionPaymentHistory}
        title={`${i18n.get(
          "READ_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"READ_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.vipSubscriptionPaymentHistory}
        title={`${i18n.get(
          "VIP_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"VIP_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.plusSubscriptionPaymentHistory}
        title={`${i18n.get(
          "PLUS_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"PLUS_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.khattabatSubscriptionPaymentHistory}
        title={`${i18n.get(
          "KHATTABAT_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"KHATTABAT_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_REWIND_BOOST_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.rewindSubscriptionPaymentHistory}
        title={`${i18n.get(
          "REWIND_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"REWIND_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_REWIND_BOOST_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.boostSubscriptionPaymentHistory}
        title={`${i18n.get(
          "BOOST_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"BOOST_SUBSCRIPTION_HISTORY_FOR"}
      />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Table
        columns={SUBSCRIPTION_REWIND_BOOST_PAYMENT_HISTORY_HEADERS}
        rows={paymentsData.otherSubscriptionPaymentHistory}
        title={`${i18n.get(
          "OTHER_SUBSCRIPTION_HISTORY_FOR"
        )} ${reducedStringUserId} `}
        shouldBeFlagged={false}
        getRowClassName={({ row }) => {
          const isFreePayment = row.paymentMethod === "free";
          if (isFreePayment) {
            return "table-free-payment-row-color";
          }
        }}
        titleKey={"OTHER_SUBSCRIPTION_HISTORY_FOR"}
      />
    </React.Fragment>
  );
});
export default UserPaymentsTables;
